<template>
  <v-container
    fluid
    fill-height
    >
    <v-row
      justify="center"
      align="center"
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Loading'
}
</script>
